// extracted by mini-css-extract-plugin
export var intro = "IssueIndex-module--intro--p4qIs";
export var overlay = "IssueIndex-module--overlay--E6kDt";
export var root = "IssueIndex-module--root--43Kkt";
export var showing = "IssueIndex-module--showing--XFgMs";
export var wrapper = "IssueIndex-module--wrapper--HDD3n";